export enum Countries {
    RU = "RU",
    KZ = "KZ",
    BY = "BY",
    DE = "DE"
}